export default __webpack_public_path__ + "f81b8b81faec9ca384d3ba76321c9cef.svg";